import { pxToRem } from '../helpers/pxToRem';

export type DsColors = keyof typeof dsColors;
export const dsColors = {
    lightGrey: '#E9EEF4',
    mediumGrey: '#B3C1D2',
    darkGrey: '#4D6580',
    blue: '#2D80E2',
    blue500: '#1F75DA',
    blue800: '#B4E7FE',
    violet: '#607BEF',
    green: '#1DC6D8',
    orange: '#FFA150',
    orange600: '#FFA150',
    orange900: '#FFF0ED',
    red: '#FF5473',
    red400: '#C61148',
    red900: '#FFE0E8',
    cyan300: '#0B848C',
    cyan500: '#25C0D1',
    cyan900: '#E1F6F9',
    yellow800: '#FFF1BE',
    violet800: '#C7C2FF',
    neutral200: '#22303F',
    neutral300: '#364C63',
    neutral400: '#4D6580',
    neutral700: '#B3C1D2',
    neutral800: '#CCD9E5',
    neutral900: '#E9EEF4',
    white: '#FFFFFF',
    black: '#000000',
    pink800: '#F79EFF',
};

export const layout = {
    containerPaddingX: pxToRem(16),
    containerWidth: pxToRem(1160),
    footerHeight: pxToRem(72),
};

export const breakPointsValues = {
    xs: 380,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1160,
};

export const breakPoints = {
    xs: pxToRem(breakPointsValues.xs),
    sm: pxToRem(breakPointsValues.sm),
    md: pxToRem(breakPointsValues.md),
    lg: pxToRem(breakPointsValues.lg),
    xl: pxToRem(breakPointsValues.xl),
};

const createMediaQuery = (rule: 'min-width' | 'max-width' | 'min-height' | 'max-height') => (
    breakPoint: keyof typeof breakPoints,
    skipMediaAnnotation?: boolean,
) => `${skipMediaAnnotation ? '' : '@media '}only screen and (${rule}: ${breakPoints[breakPoint]})`;

export const mediaQuery = {
    minWidth: createMediaQuery('min-width'),
    maxWidth: createMediaQuery('max-width'),
    minHeight: createMediaQuery('min-width'),
    maxHeight: createMediaQuery('max-height'),
};
